/**
 * Licensed to the Apache Software Foundation (ASF) under one or more
 * contributor license agreements.  See the NOTICE file distributed with
 * this work for additional information regarding copyright ownership.
 * The ASF licenses this file to You under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with
 * the License.  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ChartBrief from './chart-brief.vue';
import ChartNum from './chart-num.vue';
import ChartLine from './chart-line.vue';
import ChartBar from './chart-bar.vue';
import ChartHeatmap from './chart-heatmap.vue';
import ChartSlow from './chart-slow.vue';
import ChartTrace from './chart-trace.vue';
import ChartSankey from './chart-sankey.vue';
import ChartInstance from './chart-instance.vue';
import ChartCount from './chart-count.vue';
import ChartEdit from './chart-edit.vue';

export default {
  ChartCount,
  ChartNum,
  ChartBrief,
  ChartLine,
  ChartBar,
  ChartInstance,
  ChartHeatmap,
  ChartSlow,
  ChartTrace,
  ChartSankey,
  ChartEdit,
};
